<template>
  <section id="photos-takeover" class="photos takeover">
    <button class="btn btn-white btn-cs" @click="$emit('showphotos', false)">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#5f6368"
      >
        <path
          d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
        />
      </svg>
    </button>
    <div class="container mm">
      <div class="row py-4">
        <div
          v-for="(image, i) in images"
          class="col-12 mb-4 photo-item"
          :id="'photo-' + i"
        >
          <img width="100%" :src="image" />
        </div>

        <div class="col-12 py-5 pb-4 text-center">
          <div class="fs-1 bld">Like what you see?</div>
          <div class="fs-5 l-op">
            Have any questions or would you like to schedule a showing?
          </div>
          <div class="mt-4">
            <button
              @click="contactUs()"
              class="btn btn-outline-primary btn-contact shadow-sm px-4 py-2 f-lg lbld"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["images"],
  methods: {
    contactUs() {
      this.$emit("showphotos", false);
      $("#contact-btn")[0].click();
    },
  },
};
</script>

<style>
.takeover {
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  z-index: 6;
}
.btn-white {
  background-color: #fff;
  opacity: 1;
}
.btn-cs {
  position: fixed;
  right: 35px;
  top: 35px;
  border-radius: 8px;
  width: 45px;
  height: 45px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.photos img {
  width: 100%;
  border-radius: 4px;
  object-fit: contain;
  height: 100%;
}
.photo-item {
  max-height: 100vh;
}
</style>
